import useMutation from "src/hooks/useMutation";

function useWarehouseTransferStatus(id) {
  return useMutation({
    path: `/api/v1/warehouse-transfers/${id}/status-out`,
    method: "POST",
    mutateRelatedDataList: {
      mutatePath: `/api/v1/warehouse-transfers`,
      shouldRevalidate: true,
    },
  });
}

export default useWarehouseTransferStatus;
